import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\vocal-remover\\vocal-remover.tsx");
